module.exports = __webpack_public_path__ + "images/shoebox-904a6051965c741bc399c336e06351ed.jpg";